module.exports = __webpack_public_path__ + "img/75615.7b28fe17.svg";